/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FetchData } from 'app/shared/generalMethods';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class AdminCommunityService {
    headers: HttpHeaders;
        options: any;
        user: any;
        serverUrl = environment.apiUrl;
        serverCache = environment.apiUrlCache;

        constructor(
            private http: HttpClient,
            private _httpClient: HttpClient,
            private _fetchData: FetchData
        ){}


    updateCommunity(record: any, adminId: string): Observable<any> {

        const url = this.serverUrl + '/updateCommunity?adminId=' + adminId;
        const body = {
            communityid: record.id,
            adminIdOrUid: adminId,
            name: record.name,
            contactPhone: record.contactPhone,
            description: record.description,
            location: record.location
        };
        return this._httpClient.put(url, record, this.options);
    }

    createCommunity(communityData: any, adminId: string): Observable<any> {
            const url = this.serverUrl + '/createCommunity?adminId=' + adminId;
            const body = {
                adminIdOrUid: adminId,
                name: communityData.name,
                contactPhone: communityData.contactPhone,
                description: communityData.description,
                location: communityData.location
            };
            return this._httpClient.post(url, body, this.options);
        }

        createCommunityWithStaff(communityData: any, staffId: string, adminId: string): Observable<any> {
            const adminIdForStaff = this._fetchData.data.lstStaffData[0].Administrator__c;
  const url = this.serverUrl + '/createCommunity?staffId=' + staffId;

  const body = {
    staffId: staffId,
    adminIdOrUid: adminIdForStaff,
    name: communityData.name,
    contactPhone: communityData.contactPhone,
    description: communityData.description,
    location: communityData.location
  };

  return this._httpClient.post(url, body, this.options);
}
}
